// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-icon-warning[data-v-5ce90602] {\n  color: yellow;\n  margin-right: 2px;\n}", ""]);
// Exports
module.exports = exports;
